<template>
  <div class="lossthreshold">
    <div class="con">
      <div class="dispose">
        <div class="flow">
          <div class="title1">
            能流图损耗
          </div>
          <div class="concrete">
            <div class="item" v-for="(item,index) in flowList" :key="index">
              <div class="item-con">
                <span>损耗率</span>
                <span class="icons">{{index == flowList.length - 1 ? '＞' : '≤'}}</span>
                <el-input-number v-model="item.thresholdValue" controls-position="right" :min="1"
                  :max="100"></el-input-number>
                <span class="icons">%</span>
                <span>颜色</span>
                <p :style="{backgroundColor:item.color}"></p>
                <el-checkbox v-model="item.checked" @change="check_fn(item)"></el-checkbox>
              </div>
              <div class="item-tip">
                注：{{tip_fn(index,flowList)}} ~ {{index != 3 ? item.thresholdValue : 100}}
              </div>
              <div class="line" v-show="index != flowList.length - 1"></div>
            </div>
          </div>
        </div>


        <div class="flow">
          <div class="title1">
            线损
          </div>
          <div class="concrete">
            <div class="item" v-for="(item,index) in lineList" :key="index">
              <div class="item-con">
                <span>线损率</span>
                <span class="icons">{{index == lineList.length - 1 ? '＞' : '≤'}}</span>
                <el-input-number v-model="item.thresholdValue" controls-position="right" :min="1"
                  :max="100"></el-input-number>
                <span class="icons">%</span>
                <span>颜色</span>
                <p :style="{backgroundColor:item.color}"></p>
                <el-checkbox v-model="item.checked"></el-checkbox>
              </div>
              <div class="item-tip">
                注：{{tip_fn(index,flowList)}} ~ {{index != 3 ? item.thresholdValue : 100}}
              </div>
              <div class="line" v-show="index != lineList.length - 1"></div>
            </div>
          </div>
        </div>

        <div class="flow">
          <div class="title1">
            变损
          </div>
          <div class="concrete">
            <div class="item" v-for="(item,index) in lossList" :key="item.id">
              <div class="item-con">
                <span>变损率</span>
                <span class="icons">{{index == lossList.length - 1 ? '＞' : '≤'}}</span>
                <el-input-number v-model="item.thresholdValue" controls-position="right" :min="1"
                  :max="100"></el-input-number>
                <span class="icons">%</span>
                <span>颜色</span>
                <p :style="{backgroundColor:item.color}"></p>
                <el-checkbox v-model="item.checked"></el-checkbox>
              </div>
              <div class="item-tip">
                注：{{tip_fn(index,flowList)}} ~ {{index != 3 ? item.thresholdValue : 100}}
              </div>
              <div class="line" v-show="index != lossList.length - 1"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {diagramHintFind,diagramHintSave} from "../../api/energyFlow";
  export default {

    data () {
      return {
        num: 1,
        checked: true,
        flowList: [
          {
            thresholdValue: 3,
            color: 'green',
            checked: true
          },
          {
            thresholdValue: 5,
            color: 'yellow',
            checked: true
          },
          {
            thresholdValue: 7,
            color: 'orange',
            checked: true
          },
          {
            thresholdValue: 9,
            color: 'red',
            checked: true
          },
        ],
        lineList: [
          {
            thresholdValue: 3,
            color: 'green',
            checked: true
          },
          {
            thresholdValue: 5,
            color: 'yellow',
            checked: true
          },
          {
            thresholdValue: 7,
            color: 'orange',
            checked: true
          },
          {
            thresholdValue: 9,
            color: 'red',
            checked: true
          },
        ],
        lossList: [
          {
            thresholdValue: 3,
            color: 'green',
            checked: true
          },
          {
            thresholdValue: 5,
            color: 'yellow',
            checked: true
          },
          {
            thresholdValue: 7,
            color: 'orange',
            checked: true
          },
          {
            thresholdValue: 9,
            color: 'red',
            checked: true
          },
        ]
      };
    },

    mounted () {
      this.getDiagramHintFind(0) //能流图
      this.getDiagramHintFind(1) //线损
      this.getDiagramHintFind(2) //变损
    },

    methods: {
      //获取数据
      getDiagramHintFind (val) {

        diagramHintFind({'wasteType': val}).then(res => {
          var data=res.data
          data.forEach(item => {
            item.checked=item.checked==0? true:false
          })
          if(val==0) {
            this.flowList=data
          }
          if(val==1) {
            this.lineList=data
          }
          if(val==2) {
            this.lossList=data
          }

        })
      },
      //复选框改变
      check_fn (item) {
        item.checked=item.checked? 0:1
        var d=[item]

        diagramHintSave(d).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: '修改成功',type: 'success'});
            this.getDiagramHintFind(item.wasteType)
          } else {
            this.$message.error('修改失败');
          }
        })
      },
      // tip前值判断
      tip_fn (i,arr) {
        var num=0
        if(i==0) {
          num=0
        } else {
          num=arr[i-1].thresholdValue
          if(i==3) {
            num=arr[3].thresholdValue
          }
        }

        return num
      }
    },
    //过滤器
    filters: {

    }
  };
</script>

<style lang="scss" scoped>
  .lossthreshold {
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;

      .dispose {
        display: flex;
        margin-top: 20px;

        .flow {
          width: 33%;
          height: 480px;
          border: 1px solid #e6e6e6;
          margin-right: 12px;

          .title1 {
            width: 100%;
            height: 44px;
            background-color: #368ED9;
            color: #fff;
            font-size: 16px;
            line-height: 44px;
            padding-left: 20px;
            box-sizing: border-box;


          }

          .concrete {
            margin-top: 35px;

            .line {
              width: 100%;
              height: 1px;
              background-color: #e6e6e6;
              margin: 20px 0px;
            }

            .item {
              padding: 0px 20px;
              box-sizing: border-box;

              //    margin-left: 10px;
              .item-con {
                display: flex;
                align-items: center;
                margin-left: 10px;


                span {
                  color: #999999;
                }

                .icons {
                  // margin: 0px 12px;
                  display: inline-block;
                  width: 36px;
                  text-align: center;
                  color: #000;
                }

                p {
                  width: 40px;
                  height: 24px;
                  margin: 0px 28px 0px 12px;
                  background-color: #3ba057;
                  border-radius: 2px;
                }
              }

              .item-tip {
                font-size: 12px;
                margin-left: 88px;
              }
            }
          }
        }

      }
    }
  }
</style>